import http from "../http-common";
import axios from "axios";

class OdService {

    getImageCategories=()=>http.get(`od/imgCategories`);
    
    getContactAppointments = (contact_id, type = null) => {
        return http.get(`/od/contacts/${contact_id}/appointments`, {
          params: type ? { type } : {}
        });
      };

    getContactReliability = (contact_id) => http.get(`/od/contacts/${contact_id}/reliability`);

    getContactInsurance = (contact_id) => http.get(`/od/contacts/${contact_id}/insurance`);

    getFreeSlots = () => http.get('od/appointments/slots');

    addContactAppointment = (contact_id, data) => http.post(`/contacts/${contact_id}/appointments`, data);

    getRecare_List = (offset) => http.get(`/od/recalls/offset/${offset}`);

    getReConsultant_List = (offset) => http.get(`/od/reconsult/offset/${offset}`);

    getPostOps_List = (offset) => http.get(`/od/postops/offset/${offset}`);

    getUnConfirmedAppointment_List = (offset) => http.get(`/od/unconfirmedappts/offset/${offset}`);

    getOperatories = () => http.get(`/od/operatories`);

    getAppointments = (date, offset) => http.get(`/od/appointments/offset/${offset}/date/${date}`);

    getClinics = () => http.get(`/od/clinics`);
    
    getlabcases = (data, id) => {
        if (id) {
            return http.get(`/od/lab-cases/${id}`);
        } else {
           return http.get(`/od/lab-cases?q=${encodeURIComponent(JSON.stringify(data))}`);
        }
    };

    isODEnabled = () => http.get(`/od/enabled`);

    labnamelist = () => http.get(`/od/labs`);

    getODAccessToken = () => http.get('/od/access-token');

    saveODAccessToken = (token) => http.post('/od/access-token', { token });

    updateODAccessToken = (token) => http.put('/od/access-token', { token });

    updateLabCase = (payload) =>http.put(`/od/labcases/${payload.LabCaseNum}`, payload);

    checkLabConvoStatus = (lab_id) =>http.get(`/od/LabConvoStatus/${lab_id}`);

    getPreAuths = (offset) => http.get(`/od/PreAuths/offset/${offset}`);

    PreAuthsDetails =(id) =>http.get(`/od/PreAuthsDetails/contacts/${id}`);

    getPendingTreatment = (offset) => http.get(`/od/PendingTreatment/offset/${offset}`);

    pendingTreatmentDetails = (id) => http.get(`/od/pendingTreatmentDetails/contacts/${id}`)

    uploadFiles = (data) => axios.post(process.env.VUE_APP_API_URL + "/api/od/uploadfiles", data,{
   withCredentials: true
   });

    stageDocuments = (data) => axios.post(process.env.VUE_APP_API_URL + "/api/od/documents/stage", data,{
   withCredentials: true
   });
  
    uploadFromMessage =(text_message_id, media_id, data) =>{
      return http.post(
        `/od/documents/from-message/${text_message_id}/${media_id}`,
        data
      );
    };
  
    retryUpload = (contact_id, media_id, metadata) => {
      return http.post(
        `/od/documents/retry/${contact_id}/${media_id}`,
        metadata
        );
    }
    updateDocuments = (payload) => http.put(`/od/documents/${payload.media_id}`, payload);

    getMediaExtraction = (media_id) => http.get(`/od/media/${media_id}/extraction`);

    updateMediaExtraction = (media_id, data) => http.put(`/od/media/${media_id}/extraction`, data);

    uploadMediaToOD = (media_id, contact_id, od_category_id, short_description) => http.post(`/od/media/${media_id}/upload-to-od`, { contact_id, od_category_id, short_description });

    listOdCarriers = () => http.get(`/od/carriers`);

    searchOdInsPlans = (carrierNum) => http.get(`/od/insplans/search`, { params: { carrier_num: carrierNum } });

    listOdPlanTypes = () => http.get(`/od/insplans/plan-types`);

    listOdFeeSchedules = () => http.get(`/od/feeschedules`);

    confirmMediaInsurance = (media_id, payload) => http.post(`/od/media/${media_id}/confirm-insurance`, payload);

    addExtractionField = (document_type, field_label, visible_to_patient) =>
      http.post(`/od/extraction-fields`, { document_type, field_label, visible_to_patient });

    pushContactToOD = (contact_id) => http.put(`/od/contacts/${contact_id}`);

    createUploadLink = (contact_id, conversation_id) => http.post(`/od/upload-links`, { contact_id, conversation_id });
   
    getUnscheduled = (offset) => http.get(`/od/unscheduled/offset/${offset}`);

    getODrecalltypes = () => http.get(`/od/recalltypes`);
  
    //confirmed appointment
    confirmedAppointment = (payload) => http.put(`/od/confirmedAppointment/${payload.AptNum}/confirm`,payload);

    getSyncLogs = (params = {}) => http.get('/od/sync-logs', { params });

    // OD Filter management
    getOdFilters = () => http.get('/od/filters');
    createOdFilter = (data) => http.post('/od/filters', data);
    updateOdFilter = (id, data) => http.put(`/od/filters/${id}`, data);
    deleteOdFilter = (id) => http.delete(`/od/filters/${id}`);
    executeOdFilter = (id, offset = 0) => http.post(`/od/filters/${id}/execute`, {}, { params: { offset } });
    getOdFilterDefaultSql = (id) => http.get(`/od/filters/${id}/default-sql`);
    previewFilterSql = (sql, execution_mode) => http.post('/od/filters/preview-sql', { sql, execution_mode });
    getContactsSqlSchema = () => http.get('/od/filters/contacts-sql/schema');
    getContactsSqlValueHints = (table, column, search) => http.get('/od/filters/contacts-sql/value-hints', { params: { table, column, search } });

    // OD Filter campaign settings
    getFilterCampaign = (filterId) => http.get(`/od/filters/${filterId}/campaign`);
    saveFilterCampaign = (filterId, data) => http.put(`/od/filters/${filterId}/campaign`, data);
    getFilterRuns = (filterId) => http.get(`/od/filters/${filterId}/runs`);
    getFilterRunContacts = (filterId, executionId) => http.get(`/od/filters/${filterId}/runs/${executionId}/contacts`);
    getFilterRunSnapshot = (filterId, executionId) => http.get(`/od/filters/${filterId}/runs/${executionId}/snapshot`);
  }

export default new OdService();